import { createLegendLabelFormatter } from './truncate-legend-label';

/**
 * Creates a combined legend formatter that applies custom formatting first,
 * then truncates the result to fit within the specified length.
 *
 * @param formatLegendLabel - Custom formatting function
 * @param maxLegendLabelLength - Maximum length for truncation (optional)
 * @returns Combined formatter function
 */
export const createCombinedLegendFormatter = (
  formatLegendLabel: (label: string) => string = (label) => label,
  maxLegendLabelLength?: number
) => {
  const truncateFormatter = createLegendLabelFormatter(maxLegendLabelLength);

  return (label: string) => {
    const customFormatted = formatLegendLabel(label);
    return truncateFormatter(customFormatted);
  };
};
